import React from 'react';
import propTypes from 'prop-types';

import { FloorPlanPropTypes } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanPropTypes';
import FloorPlansPageListItem from './FloorPlansPageListItem';

import '../../GlobalScss/grid.scss';

const FloorPlansPageList = ( { items, showSoldOutStatus } ) => (
  <div className="gridContainer">
    { items?.map( ( item, index ) => (
      <FloorPlansPageListItem
        key={item?.uuid}
        data={item}
        index={index}
        showSoldOutStatus={showSoldOutStatus}
      />
    ) ) }
  </div>
);

FloorPlansPageList.propTypes = {
  items: propTypes.arrayOf( propTypes.shape( {
    data: FloorPlanPropTypes.data,
  } ) ),
  showSoldOutStatus: propTypes.bool,
};

FloorPlansPageList.defaultProps = {
  items: [],
  showSoldOutStatus: false,
};

export default FloorPlansPageList;
